import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-pie-de-pagina',
  standalone: true,
  imports: [],
  templateUrl: './pie-de-pagina.component.html',
  styleUrl: './pie-de-pagina.component.scss'
})
export class PieDePaginaComponent {
  version: string = environment.version;
}
